import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad Aggregations
 */
export class AdAggregationsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.filterName
   * @param {Array<AdAggregationListValueObject>} deps.items
   */
}
